import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  max-width: 448px;
  width: 100%;
  height: 100%;

  ${Media.Tablet`
    max-width: 540px;
  `}
`

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;

  ${Media.Phone`
    gap: 8px;
  `}
`

export const AnimationContainer = styled.div`
  max-width: 544px;
  width: 100%;
  height: 544px;
  background-color: ${Colors.Neutral5};
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;

  ${Media.Tablet`
    max-width: 540px;
    width: 100%;
    height: 336px;
  `}

  ${Media.Phone`
    height: 260px;
  `}
`

export const Video = styled.video`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  object-fit: cover;
  transform: scale(1.002);
  transform-origin: center;
`

export const ThumbnailContainer = styled.div`
  display: flex;
  width: 278px;
  height: 389.621px;
  flex-direction: column;
  justify-content: center;
  margin-top: 110px;
  border-radius: 4.18px;
  position: relative;
  box-shadow: 0px 0px 0.89px 0px rgba(15, 56, 113, 0.32),
    0px 5.339px 7.118px -1.78px rgba(15, 56, 113, 0.02),
    0px 14.237px 56.947px -7.118px rgba(15, 56, 113, 0.18);

  ${Media.Tablet`
    margin-top: 64px;
    width: 239px;
    height: 334.962px;
  `}

  ${Media.Phone`
    margin-top: 32px;
  `}
`

export const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 4.18px;
  object-fit: cover;
`

export const SuccessIcon = styled.img`
  position: absolute;
  width: 32px;
  height: 32px;
  top: -12px;
  right: -12px;
`

export const ThumbnailOverlayContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 195px;
  bottom: 0;

  ${Media.Tablet`
    height: 88px;
  `}

  ${Media.Phone`
    height: 45px;
  `}
`

export const ThumbnailOverlay = styled.div`
  width: 100%;
  height: 106px;
  background-color: ${Colors.Neutral5};

  ${Media.Tablet`
    height: 43px;
  `}

  ${Media.Phone`
    height: 0;
  `}
`

export const ThumbnailOverlayGradient = styled.div`
  width: 100%;
  height: 88px;
  background: linear-gradient(180deg, rgba(247, 249, 252, 0) 0%, ${Colors.Neutral5} 100%);

  ${Media.Tablet`
    height: 45px;
  `}
`

export const ActionsContainer = styled.div`
  width: 100%;
  margin-top: auto;
`
